import { render, staticRenderFns } from "./SalesDate.vue?vue&type=template&id=965caf1a"
import script from "./SalesDate.vue?vue&type=script&lang=js"
export * from "./SalesDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports